import { useTranslation } from 'react-i18next';
import { getOvertimeApplyUrl } from '@/constant/approval';
import type { ContentExtraProps } from '../../types';
import InfoTable from '@/components/Approval/@components/InfoTable';
import useAttendanceDetail from './useAttendanceDetail';
import {
  formatDurationHours,
  formatHoursOfLimit,
  formatPeriod,
  formatWorkingHoursRange,
} from './format';
import { AttendanceSlotRoot } from './styles';
import type { OvertimeApplyDetail } from './types';

/** 223 (신규)연장근무 신청 */
const OvertimeApplySlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const { cell } = useAttendanceDetail<OvertimeApplyDetail>(
    getOvertimeApplyUrl(data.documentId),
  );

  return (
    <AttendanceSlotRoot>
      <InfoTable
        title={t('신청자 정보')}
        rows={[
          {
            label: t('근무시간'),
            value: cell((d) =>
              formatWorkingHoursRange(d.overtime?.workingHours),
            ),
          },
        ]}
      />
      <InfoTable
        title={t('신청 내용')}
        rows={[
          { label: t('구분'), value: t('연장근무 신청') },
          {
            label: t('신청 기간'),
            value: cell((d) =>
              formatPeriod(d.overtime?.startedAt, d.overtime?.endedAt),
            ),
          },
          {
            label: t('신청 시간'),
            value: cell((d) =>
              formatDurationHours(
                d.overtime?.startedAt,
                d.overtime?.endedAt,
                t,
              ),
            ),
            emphasis: true,
          },
          { label: t('사유'), value: cell((d) => d.overtime?.reason || '-') },
        ]}
      />
      <InfoTable
        title={t('연장근무 현황')}
        rows={[
          {
            label: t('이번주 연장근무'),
            value: cell((d) =>
              formatHoursOfLimit(d.weeklyOvertimeHours, d.weeklyLimitHours, t),
            ),
          },
          {
            label: t('이번달 연장근무'),
            value: cell((d) =>
              formatHoursOfLimit(
                d.monthlyOvertimeHours,
                d.monthlyLimitHours,
                t,
              ),
            ),
          },
        ]}
      />
    </AttendanceSlotRoot>
  );
};

export default OvertimeApplySlot;
